import request from "../request";

export default {
  // 城市-列表
  list(data) {
    return request.get("/region/cityList", data);
  },

  // 县级-添加
  add(data) {
    return request.post("/region/createCity", data);
  },

  areaAdd(data) {
    return request.post("/area/add", data);
  },

  areaEdit(data) {
    return request.post("/area/edit", data);
  },

  // 县级-编辑
  edit(data) {
    return request.post("/region/updateCity", data);
  },

  // 城市-删除
  delete(data) {
    return request.post("/region/deleteCity", data);
  },

  // 城市-可关联地域
  usedRegion(data) {
    return request.get("/region/usedRegion", data);
  },

  // 城市-区域列表
  areaList(data) {
    return request.get("/region/areaList", data);
  },

  // 城市-区域新增
  createArea(data) {
    return request.post("/region/createArea", data);
  },

  // 城市-区域修改
  updateArea(data) {
    return request.post("/region/updateArea", data);
  },

  // 城市-区域删除
  deleteArea(data) {
    return request.post("/region/deleteArea", data);
  },
  // 城市-列表
  getUseCity(data) {
    return request.get("/region/getUseCity", data);
  },

  lists(data) {
    return request.get("/region/lists", data);
  }
};
